import NMenuItem from './NMenuItem';

export default NMenuItem